import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const guestToken = {
  get: () => sessionStorage.getItem("ys_preview") || localStorage.getItem("ys_guest"),
  set: (t) => localStorage.setItem("ys_guest", t),
  setPreview: (t) => sessionStorage.setItem("ys_preview", t),
  clear: () => { if (sessionStorage.getItem("ys_preview")) { sessionStorage.removeItem("ys_preview"); } else { localStorage.removeItem("ys_guest"); } },
};

export const guestApi = axios.create({ baseURL: API });
guestApi.interceptors.request.use((c) => {
  const t = guestToken.get();
  if (t) c.headers["X-Guest-Token"] = t;
  return c;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return "Something went wrong. Please try again.";
};

export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

export const ageOn = (dob, ref) => {
  if (!dob) return null;
  const b = new Date(dob);
  const r = ref ? new Date(ref) : new Date();
  let a = r.getFullYear() - b.getFullYear();
  if (r.getMonth() < b.getMonth() || (r.getMonth() === b.getMonth() && r.getDate() < b.getDate())) a -= 1;
  return a;
};

export const flag = (iso) => String.fromCodePoint(...[...iso.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)));

import { COUNTRIES, MAIN_REGION } from "@/lib/countries";

export { COUNTRIES };

export const emptyPerson = () => ({
  id: uid(), first_name: "", last_name: "", dob: "", email: "", phone_code: "+91", phone_country: "IN", phone: "",
  travel: {}, costume: {}, custom: {},
});

export const splitPhone = (raw = "") => {
  const s = raw.replace(/[^\d+]/g, "");
  if (s.startsWith("+")) {
    const m = [...COUNTRIES].sort((a, b) => b[2].length - a[2].length).find((c) => s.startsWith(c[2]));
    if (m) return { phone_country: MAIN_REGION[m[2]] || m[0], phone_code: m[2], phone: s.slice(m[2].length) };
  }
  const d = s.replace(/^0+/, "");
  if (d.length === 12 && d.startsWith("91")) return { phone_country: "IN", phone_code: "+91", phone: d.slice(2) };
  return { phone_country: "IN", phone_code: "+91", phone: d };
};

export const stayLists = (st = {}) => {
  const s = st || {};
  const hotels = s.hotels || (s.hotel ? [{ name: s.hotel, room: s.room, check_in: s.check_in, check_out: s.check_out }] : []);
  const tk = ["vehicle", "cab_number", "driver_name", "driver_mobile", "transfer_info"];
  const transfers = s.transfers || (tk.some((k) => s[k]) ? [Object.fromEntries(tk.map((k) => [k, s[k] || ""]))] : []);
  return { hotels, transfers };
};

export const mapsUrl = (q) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

export const flightKind = (field, label) => field?.option_kinds?.[label] || (/own|no flight|not need|don't need/i.test(label) ? "own" : /book/i.test(label) ? "booked" : /need|require/i.test(label) ? "need" : "own");

export const ARRIVAL_LABELS = {
  not_arrived: "Not arrived", landed: "Landed", picked_up: "Picked up", reached_hotel: "Reached hotel", departed: "Departed",
};
